module.exports = __webpack_public_path__ + "static/media/logo2.200d17cc.png";